import { combineReducers } from 'redux';
import landbot from './landbot';

export default combineReducers({
  landbot,
});
